const questionStyle = {
  questionDiv: {
    padding: "10px",
    marginTop: "55px",
    height: "calc(100vh - 55px)",
    overflow: "auto !important",
  }
};
  
export default questionStyle;